import { render, staticRenderFns } from "./BookingSlotItem.vue?vue&type=template&id=0a4ae0fb&"
import script from "./BookingSlotItem.vue?vue&type=script&lang=js&"
export * from "./BookingSlotItem.vue?vue&type=script&lang=js&"
import style0 from "./BookingSlotItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports